/**
 * Métadonnées YouTube d'une vidéo (durée, vues), lues par le back-office.
 *
 * La clé YouTube Data reste côté serveur (audit console S-2) : la console
 * n'appelle plus l'API YouTube elle-même. Route utilisateur (admins), donc
 * sur `API_URL`.
 */

import { USER_PATHS } from '../config/adminApi';
import { createApiClient } from '../lib/http';

const client = createApiClient();

/** Durée (secondes) et vues d'une vidéo YouTube. */
export interface YoutubeMetadata {
  videoId: string;
  duration: number;
  views: number;
}

/**
 * Lit la durée et les vues d'une vidéo YouTube via le backend.
 * Lève l'erreur axios (400 identifiant invalide, 404 introuvable,
 * 502/503 YouTube indisponible) : l'appelant l'affiche avec `toUserMessage`.
 */
export const fetchYoutubeMetadata = async (videoId: string): Promise<YoutubeMetadata> => {
  const response = await client.get<{ success: boolean; data: YoutubeMetadata }>(
    USER_PATHS.youtubeMetadata, { params: { videoId } });
  return response.data.data;
};
